export const APPKEY = {
  PROD: '69081f3f8560e34872dd0cf9',
  TEST: '69081f5e644c9e2c206e94d9',
}

export const IGNORE_ERROR = [
  'unhandledrejection',
  'Script error',
  'Network Error',
  'Failed to fetch',
  'Load failed',
  'Request aborted',
  'timeout of 0ms exceeded',
  'Unable to preload CSS',
  'The operation was aborted',
  'The operation is not supported',
  'Importing a module script failed',
  'The play() request was interrupted',
  'play() can only be initiated by a user gesture',
  'The element has no supported sources',
  'Failed to start the audio device',
  `ReferenceError: Can't find variable: WeakRef`,
  'requireCredential but empty token',
  'Error: createBuffer error',
  'The callback prior to sending a one-to-one chat message was triggered, and the App backend returned a response to forbid the message!',
  '已取消',
  '请求超时',
  '请求参数错误',
  '请求过于频繁，请稍后再试',
  '网络连接不佳，请稍后再试~',
  'Script error.',
  'cancel',
  'Failed to fetch',
  'Uncaught TypeError: UCShellJava.sdkEventFire is not a function',
  'The operation was aborted.',
  'Uncaught ReferenceError: LIDNotifyId is not defined',
  'Request failed with status code 503',
  'Network request failed',
  'Load failed',
  'Error: createBuffer error',
  'ResizeObserver loop completed with undelivered notifications.',
  'ResizeObserver loop limit exceeded',
  `ReferenceError: Can't find variable: _WXJS`,
  `TypeError: undefined is not an object (evaluating 'media.currentTime')`,
  'Script error.',
  'Uncaught ReferenceError: LIDNotify is not defined',
  'Failed to connect to MetaMask',
  'Uncaught Error: Can not get editor instance',
  'Error: Can not get editor instance'
]
